import { datadogLogs, type LogsEvent } from '@datadog/browser-logs';

import { config } from '../../config';

const QUERY_PARAMS_TO_REDACT = ['code'];
const redactLogEvent = (event: LogsEvent) => {
    if (!/warn|error/.test(event.status)) {
        event.status = 'warn';
    }

    for (const param of QUERY_PARAMS_TO_REDACT) {
        const regex = new RegExp(`${param}=[^&]*`, 'g');
        event.view.url = event.view.url.replace(regex, `${param}=REDACTED`);
        event.view.referrer = event.view.referrer?.replace(regex, `${param}=REDACTED`);
    }
    return true;
};

export const initDatadogLogs = () => {
    if (import.meta.env.PROD) {
        datadogLogs.init({
            clientToken: config.datadog.clientToken,
            forwardErrorsToLogs: true,
            forwardConsoleLogs: ['warn', 'error'],
            site: 'datadoghq.eu',
            sessionSampleRate: 100,
            version: config.datadog.tags.version,
            service: config.datadog.tags.service,
            env: 'prod',
            beforeSend: obj => redactLogEvent(obj),
        });
        datadogLogs.setGlobalContextProperty('account_id', config.datadog.tags.awsAccountId);
        datadogLogs.setGlobalContextProperty('account_name', config.datadog.tags.awsAccountName);
        datadogLogs.setGlobalContextProperty('team_identifier', config.datadog.tags.teamIdentifier);
    }
};
